import type { PatientGroup } from "@care-by-ella/contracts";

// TES-1308 — the patient list is paged, searched and filtered by journey on
// the server. A bare string is the search alone, first page.
export type PatientListParams = {
  q?: string;
  group?: PatientGroup;
  offset?: number;
  limit?: number;
};

export function patientListQueryString(
  params: string | PatientListParams | undefined,
): string {
  const p = typeof params === "string" ? { q: params } : (params ?? {});
  const qs = new URLSearchParams();
  if (p.q && p.q.trim()) qs.set("q", p.q.trim());
  if (p.group) qs.set("group", p.group);
  if (p.offset) qs.set("offset", String(p.offset));
  if (p.limit) qs.set("limit", String(p.limit));
  const s = qs.toString();
  return s ? `?${s}` : "";
}

// "Visar 101–200 av 312" under the table; null when everything fits on one
// page, so a short list carries no pager.
export function patientListRangeLabel(
  offset: number,
  shown: number,
  total: number,
): string | null {
  if (total <= shown && offset === 0) return null;
  if (shown === 0) return `Visar 0 av ${total}`;
  return `Visar ${offset + 1}–${offset + shown} av ${total}`;
}
